'use strict'

import Helper from '@/utils/helper'

class AbstractService {
  _processError(error) {
    if (Helper.isNull(error.axios)) {
    }
  }
}

export default AbstractService
